import React from 'react';
import { useTranslation } from 'react-i18next';
import { CloseIcon, UploadIcon, GalleryIcon } from '../icons/Icons';

interface UploadChoiceModalProps {
  isOpen: boolean;
  onClose: () => void;
  onChooseFile: () => void;
  onChooseGallery: () => void;
}

const UploadChoiceModal: React.FC<UploadChoiceModalProps> = ({
  isOpen,
  onClose,
  onChooseFile,
  onChooseGallery,
}) => {
  const { t } = useTranslation('models');

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-snapfy-surface border border-white/10 w-full max-w-md rounded-2xl shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-5 border-b border-white/10">
          <h3 className="text-lg font-extrabold text-snapfy-text-primary">
            {t('uploadChoice.title')}
          </h3>
          <button
            onClick={onClose}
            className="p-1.5 text-snapfy-text-secondary hover:text-snapfy-text-primary hover:bg-white/10 rounded-xl transition-colors"
          >
            <CloseIcon className="w-5 h-5" />
          </button>
        </div>

        {/* Options */}
        <div className="p-5 space-y-3">
          <button
            onClick={() => {
              onChooseFile();
              onClose();
            }}
            className="w-full flex items-center gap-4 p-4 bg-snapfy-bg hover:bg-[#7063f7]/10 hover:border-[#7063f7]/50 border border-white/10 rounded-xl transition-all group"
          >
            <div className="w-12 h-12 bg-snapfy-inner border border-white/10 rounded-xl flex items-center justify-center group-hover:border-[#7063f7]/50 transition-colors">
              <UploadIcon className="w-6 h-6 text-snapfy-text-secondary group-hover:text-snapfy-accent-soft transition-colors" />
            </div>
            <div className="text-left">
              <p className="text-sm font-bold text-snapfy-text-primary">{t('uploadChoice.fromPC')}</p>
              <p className="text-xs text-snapfy-text-secondary mt-0.5">{t('uploadChoice.fromPCDesc')}</p>
            </div>
          </button>

          <button
            onClick={() => {
              onChooseGallery();
            }}
            className="w-full flex items-center gap-4 p-4 bg-snapfy-bg hover:bg-[#7063f7]/10 hover:border-[#7063f7]/50 border border-white/10 rounded-xl transition-all group"
          >
            <div className="w-12 h-12 bg-snapfy-inner border border-white/10 rounded-xl flex items-center justify-center group-hover:border-[#7063f7]/50 transition-colors">
              <GalleryIcon className="w-6 h-6 text-snapfy-text-secondary group-hover:text-snapfy-accent-soft transition-colors" />
            </div>
            <div className="text-left">
              <p className="text-sm font-bold text-snapfy-text-primary">{t('uploadChoice.fromGallery')}</p>
              <p className="text-xs text-snapfy-text-secondary mt-0.5">{t('uploadChoice.fromGalleryDesc')}</p>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadChoiceModal;
